import './form-package.scss';

import { PackageFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = PackageFormSchema;
export function FormPackage() {
  const { control } = useFormContext<PackageFormSchema>();
  return (
    <div id="FormPackage" className="package">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="numPeople"
        label="Num People"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter numPeople"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="unit"
        label="Unit"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter unit"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="sizeDescription"
        label="Size Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter sizeDescription"
      />
    </div>
  );
}

export default FormPackage;